import { RouteConfig } from 'vue-router'
import { verificationRouteNames } from '@/routes/constants/location'

const SaasBuilder = () =>
  import(
    /* webpackChunkName: "saas-dashboard" */ '@/pmd/pages/saas/SaasBuilder.vue'
  ).then(m => m.default)

export const verificationRoute: RouteConfig[] = [
  {
    path: 'verification',
    name: verificationRouteNames.default,
    component: SaasBuilder,
    meta: {
      hideSideBar: false,
    },
  },
]
